












































































import Component from "vue-class-component";
import SearchButton from "front-component/components/SearchButton.vue";
import ViewList from "@/views/List.vue";
import DocumentList from "@/components/insertion/list/Document.vue";
import InsertionList from "@/components/insertion/list/List.vue";
import Detail from "@/components/insertion/Detail.vue";
import DocumentsList from "@/components/insertion/DocumentsList.vue";
import KeywordSearch from "@/components/forms/search/KeywordSearch.vue";
import MediaSearch from "@/components/forms/search/insertion/MediaSearch.vue";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import MultipleSelectSearch from "@/components/forms/search/MultipleSelectSearch.vue";
import DatePickerSearch from "@/components/forms/search/DatePickerSearch.vue";
import * as Constants from "@/Constants";
import _ from "lodash";
import { Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Http from "front-component/Http";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import InsertionRepository from "@/repositories/insertion/InsertionRepository";
import EventBus from "front-component/EventBus";
import { APPLICATION_JO } from "@/Constants";

const components = {
    SearchButton,
    InsertionList,
    DocumentList,
    Detail,
    DocumentsList,
    KeywordSearch,
    MediaSearch,
    SelectSearch,
    DatePickerSearch,
    MultipleSelectSearch,
    SelectOwner,
};

@Component({
    methods: {
        APPLICATION_JO() {
            return APPLICATION_JO;
        }
    },
    components })
export default class Document extends ViewList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("hasApplication") public hasApplication!: (application: string) => boolean;

    protected filters: object = { documentInsertion: true };
    protected orders: object = { createdAt: "DESC" };

    private optionsDocumentType = Constants.optionsDocumentType;
    private optionsSupplier: any[] = [];
    private optionsSupport: any[] = [];
    private allSupport: any[] = [];
    private loadingSupplier: boolean = false;
    private loadingSupport: boolean = false;
    private exportLoading: boolean = false;
    private hiddenComponent: string[] = [];
    private limitPerPage: number = 50;
    protected selectedDocuments: string[] = [];
    protected elements: any[] = [];

    public mounted(): void {
        if (this.currentOwnerUuid) {
            _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
            if (!this.hasApplication(APPLICATION_JO)) {
                _.set(this.filters, "documentType", "invoice_support");
            }
            this.getSuppliers();
            this.refreshListSupport();
        }
    }

    @Watch("currentOwnerUuid") public refreshSuppliersWithNewOwner(): void {
        this.hiddenComponent = [];
        if (this.currentOwnerUuid) {
            _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
            this.getSuppliers();
        }
    }

    @Watch("filters.supplier") private changeFiltersSupplier() {
        this.refreshListSupport();
    }

    public get exportDisabled(): boolean {
        return 0 === this.selectedDocuments.length || this.exportLoading
            || this.selectedDocuments.length > this.limitPerPage;
    }

    public updateSelectedDocumentUuids(documentUuids: string[]) {
        this.selectedDocuments = documentUuids;
    }

    public updateFilter(filter: object): void {
        this.filters = Object.assign({}, this.filters, filter);
    }

    private downloadCompressedArchive(): void {
        this.downloadDocumentFromUuidChecked("download_zip", "export-documents.zip");
    }

    private downloadDocumentFromUuidChecked(uri: string, documentName: string): void {
        this.exportLoading = true;
        Http.download(
            this.$router.resolve({ name: uri }).href,
            { uuid: this.selectedDocuments } ,
            (data: Blob) => {
                const url = window.URL.createObjectURL(data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", documentName);
                link.click();
                this.exportLoading = false;
            },
            () => {
                this.exportLoading = false;
                EventBus.$emit("error-alert", {message: "errorDownloadDocument"});
            }
        );
    }

    private redirectUrl(name: string): void {
        this.$router.push({ name });
    }

    private getSuppliers(): void {
        if (!this.currentOwnerUuid) {
            return;
        }
        this.loadingSupplier = true;
        this.loadingSupport = true;

        this.$delete(this.filters, "supplier");
        this.optionsSupplier = [{ key: "", label: "allSuppliers" }];

        this.$delete(this.filters, "support");

        const paramsGetSupplier = {
            fields: [
                "advertisingSpace.supplier",
                "advertisingSpace.support",
            ],
            filters: {
                listSupplier: true,
                ownerUuid: this.currentOwnerUuid,
            }
        };
        this.allSupport = [];
        InsertionRepository.get(paramsGetSupplier).then((data: object[]) => {
            _.forEach(data, (line) => {
                if (!_.find(this.optionsSupplier, (o) => {
                    return o.key === _.get(line, "advertisingSpace.supplier");
                })) {
                    this.optionsSupplier.push({
                        key: _.get(line, "advertisingSpace.supplier"),
                        label: _.get(line, "advertisingSpace.supplier")
                    });
                }

                this.allSupport.push({
                    key: _.get(line, "advertisingSpace.support"),
                    label: _.get(line, "advertisingSpace.support"),
                    parent: _.get(line, "advertisingSpace.supplier")
                });
            });
            this.loadingSupplier = false;
            this.loadingSupport = false;
            this.refreshListSupport();
        });
    }

    private refreshListSupport(): void {
        this.$delete(this.filters, "support");
        const selectedSupplier = _.get(this.filters, "supplier");

        this.optionsSupport = [];

        _.forEach(this.allSupport, (supportLine) => {
            if (supportLine.parent === selectedSupplier || !selectedSupplier ) {
                this.optionsSupport.push({
                    key: supportLine.key,
                    label: supportLine.label
                });
            }
        });
        this.optionsSupport = _.uniqBy(
            this.optionsSupport.sort((a, b) => a.label.localeCompare(b.label)),
            (option) => option.label
        );
        this.optionsSupport.unshift({ key: "", label: "allSupports" });
    }
}
